import { IconMembers } from "components/icons/IconMembers";
import * as React from "react";
import { MprcIconButton, MprcIconButtonProps } from "../MprcIconButton";
import { useMprcTheme } from "../MprcThemeProvider";

export const IconButtonExpandMembers: React.FC<MprcIconButtonProps> = ({ title, ...rest }) => {
    const { theme } = useMprcTheme();
    const lTitle = title || theme.iconButtons.IconButtonExpandMembers.title;

    return (
        <MprcIconButton
            {...rest}
            title={lTitle}
        >
            <IconMembers fixedWidth />
        </MprcIconButton>
    );
};
